import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL_AFINZ;

const apiAfinz = axios.create({
  baseURL: BASE_URL,
});

export { apiAfinz }
